module.exports = __webpack_public_path__ + "static/media/userlist.1e7c6f4e.svg";